var render = function (_h,_vm) {var _c=_vm._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"31.067","height":"31.066","viewBox":"0 0 31.067 31.066"}},[_c('path',{attrs:{"d":"M12.224,22h0V10H0L22,0Z","transform":"translate(14.718) rotate(42)"}})])}
var staticRenderFns = []

export { render, staticRenderFns }